import React from "react";
import { Icon } from "semantic-ui-react";

const SocialMediaIcons = ({ size = "large" }) => {
  return (
    <div className="social-icons">
      <a href="https://www.linkedin.com/in/paul-carter-2334b356/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn profile">
        <Icon name="linkedin" size={size} />
      </a>
      <a href="https://github.com/carterpaul1" target="_blank" rel="noopener noreferrer" aria-label="GitHub profile">
        <Icon name="github" size={size} />
      </a>
    </div>
  );
};

export default SocialMediaIcons;
